/** Only explicit HTTP(S) links may be handed to the system browser. */
export function externalNativeUrl(href: string, origin: string): string | null {
  try {
    const url = new URL(href, origin);
    return ['https:', 'http:'].includes(url.protocol) && url.origin !== origin
      ? url.href
      : null;
  } catch {
    return null;
  }
}

export function nativeBackAction(canGoBack: boolean): 'back' | 'minimize' {
  return canGoBack ? 'back' : 'minimize';
}